import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import TopHeader from '../../template/TopHeader';
import MarketingTopNav from '../MarketingTopNav';
import MarketingHomePage from '../../marketing-v2/features/home/MarketingHomePage';
import { useMarketingControl, SalonRunsMarketingBanner } from '../SalonRunsMarketing';
import { MARKETING_HOME_VISIBLE } from '../../../config/featureFlags';
import '../campaigns/Campaigns.css';

/**
 * Marketing › Home
 * The command centre: Bailey's plans (text, email and posts, ready to
 * approve), what's going out this week, what marketing is bringing in, and
 * every part of marketing a tap away. Behind MARKETING_HOME_VISIBLE.
 */
const CreateMenu = ({ history }) => {
  const [open, setOpen] = useState(false);
  // Opened below the home, so their Back comes back here
  const items = [
    { label: 'A social post', go: () => history.push('/marketing-social', { create: true, from: '/marketing-home' }) },
    { label: 'An email campaign', go: () => history.push('/marketing-campaigns', { compose: 'email', from: '/marketing-home' }) },
    { label: 'An SMS blast', go: () => history.push('/marketing-campaigns', { compose: 'sms', from: '/marketing-home' }) },
  ];
  return (
    <div style={{ position: 'relative' }}>
      <button type="button" className="catalogue-add-btn" onClick={() => setOpen((o) => !o)} aria-haspopup="menu" aria-expanded={open}>
        Create
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: 6 }}><polyline points="6 9 12 15 18 9" /></svg>
      </button>
      {open && (
        <>
          <div style={{ position: 'fixed', inset: 0, zIndex: 9998 }} onClick={() => setOpen(false)} />
          <div role="menu" className="mh-menu">
            {items.map((it) => (
              <button key={it.label} type="button" role="menuitem" onClick={() => { setOpen(false); it.go(); }}>{it.label}</button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

function MarketingHome(props) {
  const control = useMarketingControl();
  if (!MARKETING_HOME_VISIBLE) return <Redirect to="/marketing-campaigns" />;
  return (
    <div className="h_n catalogue-no-header">
      <div className="body_container cm_bg_white">
        <TopHeader title="" {...props} />
        <div className="catalogue-page-wrapper">
          <MarketingTopNav activeTab="home">
            {control.managed ? null : <CreateMenu history={props.history} />}
          </MarketingTopNav>
          <div className="catalogue-content-container">
            {control.managed && <SalonRunsMarketingBanner salonName={control.salonName} />}
            <MarketingHomePage dispatch={props.dispatch} user={props.user} history={props.history} managed={control.managed} />
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return { user: state.user };
}

export default connect(mapStateToProps)(MarketingHome);
